/*
 * @Author: qiaoshiteng
 * @Date: 2023-11-27 17:14:23
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2024-03-14 17:02:21
 * @Description:
 */
import config from "@/config";
import http from "@/utils/request";
export default {
	airfactory: {
		list: {
			url: `${config.MAIN_URL}/api/v1/jw/airfactoryData`,
			name: '查询厂家列表',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/jw/airfactorySave`,
			name: '保存厂家',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		update: {
			url: `${config.MAIN_URL}/api/v1/jw/airfactoryUpate`,
			name: '修改厂家',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/jw/airfactoryDel`,
			name: '删除厂家',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
	},
	signatureMng: {
		queryByPage: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/queryByPage`,
			name: "签名分页查询",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		querySignatureByUserid: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/querySignatureByUserId`,
			name: "根据用户id查询签名",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},

		queryCompany: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/queryCompany`,
			name: "签名管理-公司下拉",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},

		queryCompanyCascadeUser: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/queryCompanyCascadeUser`,
			name: "签名管理-人员级联下拉",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addSignature: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/addSignature`,
			name: '签名新增',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		updateSignatureStatus: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/updateSignatureStatus`,
			name: '签名禁用启用',
			put: async function (params) {
				return await http.put(this.url + params);
			},
		},
		deleteSignature: {
			url: `${config.MAIN_URL}/api/v1/jw/signatureMng/deleteSignature`,
			name: '签名删除',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},

	},
	airStatus: {
		airStatusData: {
			url: `${config.MAIN_URL}/api/v1/jw/airStatusData`,
			name: '查询航空器每日状态',
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/jw/airStatusSave`,
			name: '保存厂家',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		airStatusHis: {
			url: `${config.MAIN_URL}/api/v1/jw/airStatusHis`,
			name: '修改厂家',
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
	},

	airControl: {
		data: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlList`,
			name: '查询监控列表',
			get: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlSave`,
			name: '保存监控记录',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		update: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlUpdate`,
			name: '修改监控记录',
			post: async function (params) {
				return await http.post(this.url + params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlDel`,
			name: '删除监控记录',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
		infoSave: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlInfoSave`,
			name: '保存监控记录',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		type: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlType`,
			name: '修改装机状态',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		info: {
			url: `${config.MAIN_URL}/api/v1/jw/airControlInfoData`,
			name: '定检记录列表',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},

	},
	statistic: {
		hour: {
			url: `${config.MAIN_URL}/api/v1/jw/statisticHour`,
			name: '查询监控列表',
			get: async function (params) {
				return await http.post(this.url, params);
			},
		},
		oil: {
			url: `${config.MAIN_URL}/api/v1/jw/statisticOil`,
			name: '查询监控列表',
			get: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	oilCalculation:{
		list:{
			url: `${config.MAIN_URL}/api/v1/jw/jwOilCalculation`,
			name: '查询监控列表',
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		add:{
			url: `${config.MAIN_URL}/api/v1/jw/jwOilCalculation`,
			name: '查询监控列表',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		edit:{
			url: `${config.MAIN_URL}/api/v1/jw/jwOilCalculation`,
			name: '查询监控列表',
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		remove:{
			url: `${config.MAIN_URL}/api/v1/jw/jwOilCalculation`,
			name: '查询监控列表',
			delete: async function (params) {
				return await http.delete(this.url+ params);
			},
		},
	},
	flyTasks:{
		list: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask/web`,
			name: "查询飞行任务列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask`,
			name: "保存飞行任务",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		update: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask`,
			name: "修改飞行任务",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask`,
			name: '删除飞行任务',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
		get: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask/byId`,
			name: "回显飞行任务",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
		sign: {
			url: `${config.MAIN_URL}/api/v1/hw/hwFlyTask/sign`,
			name: "签名",
			get: async function (params) {
				return await http.get(this.url + params);
			},
		},
	}
}

